import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Select, MenuItem, FormControl } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import styles from './ResponsiveTable.module.scss'

/**
 * TablePagination - Shared pagination component for both desktop and mobile layouts.
 */
const TablePagination = ({
  page,
  totalPages,
  onPageChange,
  limit,
  onLimitChange,
  limitOptions,
  isCompact
}) => {
  if (!totalPages || totalPages <= 1) return null

  return (
    <div className={`${styles.pagination} ${isCompact ? styles.paginationCompact : ''}`}>
      {/* Limit selector (optional) */}
      {onLimitChange && limitOptions && (
        <Box className={styles.pagination__limitSelector}>
          <Typography className={styles.pagination__limitLabel}>Show:</Typography>
          <FormControl variant='outlined' size='small'>
            <Select
              value={limit}
              onChange={(e) => onLimitChange(e.target.value)}
              className={styles.pagination__limitSelect}
              aria-label='Rows per page'
            >
              {limitOptions.map((opt) => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography className={styles.pagination__limitLabel}>per page</Typography>
        </Box>
      )}

      {/* Pagination controls */}
      <Box className={styles.pagination__controls}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={onPageChange}
          color='primary'
          showFirstButton
          showLastButton
          size={isCompact ? 'medium' : 'large'}
        />
      </Box>

      {/* Spacer for centering when limit selector is present */}
      {onLimitChange && limitOptions && (
        <Box className={styles.pagination__spacer} />
      )}
    </div>
  )
}

TablePagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  limit: PropTypes.number,
  onLimitChange: PropTypes.func,
  limitOptions: PropTypes.arrayOf(PropTypes.number),
  isCompact: PropTypes.bool
}

export default React.memo(TablePagination)
